import styled from 'styled-components';
import { CSSVars } from '../../styles/styles.config';

export const StyledHero = styled.section`
	background-color: ${CSSVars.gray700};
	padding: 50px 20px 50px;
	display: flex;
	gap: 30px;
	flex-wrap: wrap;
	max-width: 1420px;
	margin: 0 auto;
	justify-content: space-between;
	flex-direction: column-reverse;

	@media screen and (min-width: ${CSSVars.breakpointLG}) {
		flex-direction: row;
	}

	.img-wrapper {
		width: 350px;
		height: 320px;
		max-width: 100%;
		position: relative;
		margin: 0 auto;

		svg {
			max-width: 100%;
		}

		img {
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			width: 80px;
			height: 80px;
			object-fit: contain;
			margin-top: -20px;
			margin-left: 10px;

			/* &.search-exists {
				transform: translate(-35%, -75%);
			} */

			/* @media screen and (min-width: ${CSSVars.breakpointLG}) {
				top: calc(50% - 5px);
			} */
		}
	}

	@media screen and (min-width: ${CSSVars.breakpointLG}) {
		padding: 140px 40px 60px;
	}

	@media screen and (min-width: ${CSSVars.breakpointXL}) {
		padding: 140px 0 60px;
	}

	.hero-content-container {
		color: ${CSSVars.white};
		position: relative;
		flex: 1;

		h1 {
			font-weight: 600;
			position: relative;
			z-index: 10;
			font-size: ${CSSVars.fontSize2XL};
			margin-top: 20px;

			@media screen and (min-width: ${CSSVars.breakpointXL}) {
				font-size: ${CSSVars.fontSize4XL};
			}
		}

		h2 {
			font-weight: 300;
			font-size: ${CSSVars.fontSizeLG};
			position: relative;
			z-index: 10;

			margin: 20px 0 50px;

			@media screen and (min-width: ${CSSVars.breakpointXL}) {
				font-size: ${CSSVars.fontSizeXL};
			}

			span {
				color: ${CSSVars.primary500};
			}
		}

		.search-box {
			width: 100%;
			max-width: 440px;
		}

		form {
			position: relative;
			z-index: 10;
			margin: 0;
		}
	}
`;
